// extracted by mini-css-extract-plugin
export var actions = "_dp-d";
export var benefitCard = "_dp-a";
export var benefitIcon = "_dp-b";
export var benefitLabel = "_dp-c";
export var benefits = "_dp-9";
export var bodyText = "_dp-8";
export var closeButton = "_dp-2";
export var content = "_dp-3";
export var eyebrow = "_dp-4";
export var heading = "_dp-5";
export var image = "_dp-f";
export var imagePanel = "_dp-e";
export var modal = "_dp-0";
export var shell = "_dp-1";
export var title = "_dp-6";
export var titleOffer = "_dp-7";